import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { ICON_TYPE, IconButton } from "../../components/font-icons/IconButton";
// import { isMobile } from "react-device-detect";
// import * as Actions from '../../store/actions';
// import {
//   toggleControlsHover
// } from '../../store/actions/controls-visibility-actions';
import {
  toggleGalleryVisibility
} from '../../store/actions/header-actions';
// import * as SwitcherActions from '../../store/actions/mode-switcher-actions';
// import { IconButton, ICON_TYPE } from '../../components/font-icons/IconButton'

import {
  hideChapters,
} from '../../store/actions/header-actions';
import {
  setFrameToView,
} from '../../store/actions/play-actions';

import {
  getIsAudioBook,
  getAudioBookChapters,
  getCurrentAudioChapter,
  getGalleryVisibility,
  getActiveFrame,
} from '../../store/selectors/selectors';


import "./AudioChapters.scss";

class AudioChapters extends Component {


  activateChapter = (chapter) => {
    this.props.setFrameToView(chapter);
  }

  closeChapters = () => {
    this.props.toggleGalleryVisibility();
  }

  render() {
    const {
      audioChapters,
      isVisible,
      activeFrame,
      isAudioBook,
    } = this.props;

    if (!isAudioBook) { return null };

    const itemClassName = 'audio-chapters__item'

    //todo: fix chapter names in DB
    function getChapterName(chapter) {
      if (audioChapters.length < 10) return chapter.fname;
      return chapter.fname.replace(/^([0-9])+\s/g, '');
    }

    return (
      <div className={cx(
        'audio-chapters',
        {
          'audio-chapters--is-visible': isVisible
        }
      )}
      >
        <div
          className="audio-chapters__overlay"
          onClick={this.closeChapters}
        />
        <div className="audio-chapters__body">
          <div className="audio-chapters__title-container">
            <IconButton
              className="audio-chapters__close"
              type={ICON_TYPE.CLOSE}
              onClick={this.closeChapters}
            />
            <h3 className="audio-chapters__title-text">Contents</h3>
          </div>
          <div className="audio-chapters__list">
            {audioChapters.map((chapter, index) => (

              <div
                key={chapter.id}
                className={cx(
                  itemClassName,
                  {
                    [`${itemClassName}--active`]: activeFrame === index
                  }
                )}
                onClick={() => this.activateChapter(index)}
              >
                {getChapterName(chapter)}
              </div>
            ))

            }
          </div>
        </div>
      </div>
    );
  };

}


const mapStateToProps = state => {
  return {
    isVisible: getGalleryVisibility(state),
    currentAudioChapter: getCurrentAudioChapter(state),
    audioChapters: getAudioBookChapters(state),
    isAudioBook: getIsAudioBook(state),
    activeFrame: getActiveFrame(state),
  }
};

const actionCreators = {
  hideChapters,
  toggleGalleryVisibility,
  setFrameToView,
}

export default connect(mapStateToProps, actionCreators)(AudioChapters)



// WEBPACK FOOTER //
// ./src/containers/audio-chapters/AudioChapters.jsx